import { Component, ChangeDetectorRef, ViewChild } from '@angular/core';
import { ApiService } from '../../../../../shared/services/api.service';
import { API_ENDPOINTS } from '../../../../../shared/utils/const';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';

interface Option {
  label: string;
  value: string;
}

interface Question {
  Placeholder: string;
  answer?: any;
  dependentOn?: string | null;
  dependentValue?: string | null;
  headerText?: string | null;
  inputType: 'radio' | 'text' | 'dropdown' | 'slider' | 'multiselect' | 'label' | 'radioLevel' |'inputBox';
  isActive: boolean;
  max?: number | null;
  min?: number | null;
  options?: Option[] | null;
  optionsList?: Option[] | null;
  questionId: any;
  questionNumber: number;
  questionText: string;
  isRequired: boolean;
  minLength: number;
  maxLength: number;
  regexPattern: string;
}

interface Section {
  sectionTitle: string;
  questions: Question[];
}

interface FormValues {
  [key: string]: { [subKey: string]: string };
}

interface UserQuestions {
  UserId: any;
  UserType: number;
  msmeQuestionAnswerMapping: any[];
}

@Component({
  selector: 'app-otheruserdetails',
  templateUrl: './otheruserdetails.component.html',
  styleUrls: ['./otheruserdetails.component.css']
})
export class OtheruserdetailsComponent {
  form!: FormGroup;
  responseData: Section[] = [];
  currentSectionIndex = 0;
  msmeQuestionAnswerMapping: any[] = [];
  selectedObjects: any[] = [];
  selectedObjectsFromArray: any;
  otherInputControl!: FormControl;
  dependentControlVisible: { [key: string]: boolean } = {};

  constructor(
    private fb: FormBuilder,
    private apiService: ApiService,
    private toastrService: ToastrService,
    private router: Router
  ) { }

  ngOnInit(): void {
  
    const obj = {
      MsMeId: sessionStorage.getItem("userId"),
      UserType: 4
    };
    this.createForm(obj);
  }

  createForm(obj: any) {
    this.form = this.fb.group({});
    this.apiService.getRequest(API_ENDPOINTS.MSME.GETOTHERDETAILS, obj).subscribe(
      (response: Section[]) => {
        this.responseData = response;

    this.defaultOtherValue=this.responseData[4].questions[1].answer

        this.responseData.forEach((section) => {
          const sectionGroup = this.fb.group({});

          section.questions.forEach((question) => {
            if (question.isActive && question.questionId) {
              const control = new FormControl(
                question.answer || '',
                this.getValidators(question)
              );


              if (question.questionId === 8 || question.questionId === 9 || question.questionId === 10) {
                control.valueChanges.subscribe(() => {
                  this.calculateTotalEmployees();
                });
              }

              if (question.questionId === 24) {
                control.valueChanges.subscribe((value) => {
                  //control.clearValidators();
                  this.onInputPanChange(value, sectionGroup, question.questionId);                  
                });
              }


              // Add dependency logic for dynamic calculation
              if (question.questionId === 31 || question.questionId === 32) {
                control.valueChanges.subscribe(() => {
                  this.calculateNetTurnover(); 
                });
              }

              // If the question is the dependent one, we'll have a default value for it, but it will be updated dynamically
              if (question.questionId === 33) {
                // Optionally, pre-fill Net Turnover with an initial calculated value
                this.calculateNetTurnover();
              }

              sectionGroup.addControl(`question_${question.questionId}`, control);

              if (question.dependentOn) {
                this.setDependency(sectionGroup, question);
              }

              if (question.inputType === 'multiselect') {
                const multiselectAnswers = section.questions
                  .filter(q => q.inputType === 'multiselect')
                  .flatMap(q => JSON.parse(q.answer || '[]'));

                this.selectedObjects = multiselectAnswers;

              }
            }
          });

          this.form.addControl(section.sectionTitle, sectionGroup);
        });
        this.calculateNetTurnover();
      },
      (error) => {
        this.toastrService.error('Error fetching details', 'Oops...');
      }
    );
  }

  panValidationMessageMap: { [sectionTitle: string]: string } = {}; 
  onInputPanChange(value: string, sectionGroup: FormGroup, questionId: number): void {
    if (!value) return;

    let input = value.toUpperCase().replace(/[^A-Z0-9]/g, '');
    let formattedInput = '';

    for (let i = 0; i < input.length && i < 10; i++) {
      if ((i < 5 || i === 9) && /[A-Z]/.test(input[i])) {
        formattedInput += input[i];
      } else if (i >= 5 && i < 9 && /\d/.test(input[i])) {
        formattedInput += input[i];
      } else {
        break;
      }
    }

    const control = sectionGroup.get(`question_${questionId}`);
    if (!control) return;

    // Update value without triggering recursion
    control.setValue(formattedInput, { emitEvent: false });
    control.markAsTouched(); // ensure touched state is applied

    // PAN regex check
    const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;
    if (formattedInput && !panRegex.test(formattedInput)) {
      control.setErrors({ invalidPan: true });
    } else {
      const errors = control.errors;
      if (errors && errors['invalidPan']) {
        delete errors['invalidPan'];
        control.setErrors(Object.keys(errors).length ? errors : null);
      }
    }

    // Get section title
    const sectionTitle = Object.keys(this.form.controls).find(key =>
      this.form.get(key) === sectionGroup
    );

    if (sectionTitle) {
      // Get the message and store it
      const message = this.getPanValidationMessage(sectionTitle);
      this.panValidationMessageMap[sectionTitle] = message;
    }
  }



  getPanValidationMessage(sectionTitle: string): string {
    const control = this.form.get(sectionTitle)?.get('question_24');

    if (control && control.touched && control.invalid) {
      if (control.errors?.['required']) {
        return 'IEC Number is required.';
      }
      if (control.errors?.['pattern'] || control.errors?.['invalidPan']) {
        return 'Please enter a valid IEC Number (e.g., ABCDE1234F).';
      }
    }

    return '';
  }

  calculateNetTurnover() {
  const totalTurnover = this.form.get('Financial')?.get('question_31')?.value || 0; // Get value of Total Turnover (question 25)
  const exportTurnover = this.form.get('Financial')?.get('question_32')?.value || 0; // Get value of Export Turnover (question 26)
  
  // Calculate Net Turnover as the difference between Total Turnover and Export Turnover
  const netTurnover = totalTurnover - exportTurnover;

  // Update the form control for Net Turnover (question 27)
  this.form.get('Financial')?.get('question_33')?.setValue(netTurnover);
}

  calculateTotalEmployees() {
    const male = Number(this.form.get('MSME Baseline')?.get('question_8')?.value) || 0;
    const female = Number(this.form.get('MSME Baseline')?.get('question_9')?.value) || 0;
    const other = Number(this.form.get('MSME Baseline')?.get('question_10')?.value) || 0;
    
    // Calculate Net Turnover as the difference between Total Turnover and Export Turnover
    const totalEmployees = male + female + other;

    // Update the form control for Net Turnover (question 27)
    this.form.get('MSME Baseline')?.get('question_11')?.setValue(totalEmployees);
  }

  otherText: string = ''; 
  defaultOtherValue = 'Default Value';
  onInputChange(event: Event): void {
    this.defaultOtherValue = (event.target as HTMLInputElement).value;
  }

  isOtherSelected(): boolean {
    return this.selectedObjects.some(el => el.label === 'Other');
  }
   
  getValidators(question: Question) {
    const validators = [];
    if (question.isRequired) validators.push(Validators.required);
    if (question.minLength) validators.push(Validators.minLength(question.minLength));
    if (question.maxLength) validators.push(Validators.maxLength(question.maxLength));
    if (question.regexPattern) validators.push(Validators.pattern(question.regexPattern));
    return validators;
  }

  setDependency(sectionGroup: FormGroup, question: Question) {
    const parentControl = sectionGroup.get(`question_${question.dependentOn}`);
    const dependentControl = sectionGroup.get(`question_${question.questionId}`);

    // Disable initially, will be enabled based on value changes
    dependentControl?.disable();

    question.isActive = false;
    this.dependentControlVisible[question.questionId] = false;

    // Enable if the dependent field already has data
    if (question.answer !== null && question.answer !== '') {
      dependentControl?.enable();
      question.isActive = true;
      this.dependentControlVisible[question.questionId] = true;
    }

    // Subscribe to parent control's value changes
    parentControl?.valueChanges.subscribe((value) => {
      if (value === question.dependentValue) {
        dependentControl?.enable();
        question.isActive = true;
        this.dependentControlVisible[question.questionId] = true;
      } else {
        dependentControl?.disable();
        dependentControl?.reset();
        question.isActive = false;
        this.dependentControlVisible[question.questionId] = false;
      }
    });
  }

  nextSection() {
    const currentSection = this.form.get(this.responseData[this.currentSectionIndex].sectionTitle);
    if (currentSection?.valid) {
      this.currentSectionIndex++;
    } else {
      currentSection?.markAllAsTouched();
      this.toastrService.error('Please complete all required fields before proceeding.');
    }
  }

  previousSection() {
    this.currentSectionIndex--;
  }

  onSubmit() {
    const allValues: FormValues = this.form.getRawValue();  
    this.msmeQuestionAnswerMapping = Object.entries(allValues).flatMap(
      ([sectionKey, section]) =>
        Object.entries(section)
          .map(([key, value]) => {
            if (key.startsWith('question_')) {
              const questionNumber = key.split('_')[1];         
              const formattedValue = Array.isArray(value)
                ? JSON.stringify(value) 
                : value?.toString() || '';       
              return { questionId: Number(questionNumber), answer: formattedValue };
            }
            return null;
          })
          .filter((item) => item !== null) // Filter out any null values
    );
    this.msmeQuestionAnswerMapping = this.msmeQuestionAnswerMapping.map(item =>
      item.questionId === 35 ? { ...item, answer: this.defaultOtherValue } : item
    );

    const question34 = this.msmeQuestionAnswerMapping.find((item: any) => item.questionId === 34);

    let answerArray = [];
    answerArray = JSON.parse(question34?.answer);  // Parse the JSON string into an array
    

    // Check if 'Other' is present in the parsed array
    const hasOther = answerArray.some((option: any) => option.label === 'Other');

    // If 'Other' is not found, set question_35's value to an empty string
    if (!hasOther) {
      this.msmeQuestionAnswerMapping = this.msmeQuestionAnswerMapping.map((item: any) =>
        item.questionId === 35 ? { ...item, answer: '' } : item
      );
    }

    

    // Prepare the result object for submission
    const resultList: UserQuestions = {
      UserId: sessionStorage.getItem("userId"),
      UserType: 4,
      msmeQuestionAnswerMapping: this.msmeQuestionAnswerMapping,
    };

    // Remove unnecessary properties if present
    if ('isNewEntry' in resultList) {
      delete resultList.isNewEntry;
    }

    // Send the data to the backend
    this.apiService.postRequest(API_ENDPOINTS.MSME.SAVEMSMEQUESTIONANSWE, resultList).subscribe(
      (response: any) => {
        if (response.status) {
          this.router.navigateByUrl('/msmeuserprofile');
          this.toastrService.success(response.message, 'Good job!');
        } else {
          this.toastrService.error('An unexpected error occurred', 'Oops...');
        }
      },
      (error: any) => {
        this.toastrService.error(error.error.message, 'Oops...');
      }
    );
  }

  hasError(sectionTitle: string, questionId: string, errorType: string) {
    const control = this.form.get(sectionTitle)?.get(`question_${questionId}`);
    return control?.hasError(errorType) && control.touched;
  }

  comparer(o1: any, o2: any): boolean {
    return o1 && o2 ? o1.label === o2.label : o2 === o2;
  }
}
